export default "__VITE_ASSET__BEXJoYXg__"